import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
   context.returnMessage = response.data.msg;
   context.isReturnMessage = true;
   context.loading = false;
};

// When the request fails
const failed = (error, context) => {
    context.loading = false;
    context.showToasterError(error);
};

export default (context, action, hash, type) => {
  return Vue.$http.post('/open-close-door', { "hash" : hash, "action" : action, 'type': type })
        .then((response) => {
        if (response && response.status === 200) {
            success(response, context);
        } else {
            failed();
        }
})
.catch((error) => {
    failed(error, context);
});
};



// WEBPACK FOOTER //
// ./src/app/services/rental/openOrCloseDoor.js